import { Api } from '../../Api';

export class PreferencesManagement {
    private static _basePath = '/Preferences';

    public static getMethods(parentPath: string) {
        const basePath = `${parentPath}${PreferencesManagement._basePath}`;

        return {
            async post(body: any) {
                const path = '/';

                return await Api.post<any>({
                    path: `${basePath}${path}`,
                    body,
                });
            },
            async upsert(body: any) {
                const path = '/Upsert';

                return await Api.post<any>({
                    path: `${basePath}${path}`,
                    body,
                });
            },
            async upsertThresholds(body: any) {
                const path = '/UpsertThresholds';

                return await Api.post<any>({
                    path: `${basePath}${path}`,
                    body,
                });
            },
            async get(userId: number) {
                const path = `?userId=${userId}`;
                return await Api.get<any>({
                    path: `${basePath}${path}`,
                });
            },
            async getThresholds(userId: number) {
                const path = `/GetThresholds?userId=${userId}`;
                return await Api.get<any>({
                    path: `${basePath}${path}`,
                });
            },
            async getGroupedThreshold() {
                const path = '/GetGroupedThreshold';
                return await Api.get<any>({
                    path: `${basePath}${path}`,
                });
            },
        };
    }
}
